(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-body"]) return;
  try {
    
  const accordion = document.querySelector('.accordion');
  const accordionContent = document.querySelector('.accordion-content');
  const accorpositive = document.querySelector('.accor-plus-img');
  if (accordion) {
    accordion.addEventListener('click', () => {
      accorpositive.classList.toggle('rotate');
      accordionContent.classList.toggle('active');
    });
  }

  } catch(e) { console.error(e); }
})();
})();
